import React, { memo } from 'react'

import { Icon } from '@/components/Icon'

interface Props {
  currentSlide: number
  totalSlides: number
}

const CarouselLegend = memo(({ currentSlide, totalSlides }: Props) => (
  <div
    className="eu-flex eu-fjcc"
    aria-live="polite"
    aria-atomic="true"
    aria-label={`${currentSlide + 1} de ${totalSlides}`}
  >
    {[...new Array(totalSlides)].map((_item, index) => (
      <Icon
        icon="bullet"
        color={index === currentSlide ? 'pink' : 'surface-silver'}
        key={`cd-${index}`}
      />
    ))}
  </div>
))

CarouselLegend.displayName = 'CarouselLegend'

export default CarouselLegend
